module.exports = __webpack_public_path__ + "img/mattress.4e7024df.jpg";